import React from 'react';
import CountUp from 'react-countup';
import products from '../products.json';
import misc from '../misc.json';
import { FaEnvelope, FaMapMarkerAlt, FaMobileAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Masonry } from '@mui/lab';
import { generateFullTitle } from '../helpers';
import SEO from './SEO';
import LanguageSwitcher from './LanguageSwitcher';

const App = () => {
    const { t, i18n } = useTranslation();
    const currentLang = (i18n.language || 'hy').slice(0, 2);
    const langPrefix = currentLang === 'hy' ? '' : '/' + currentLang;

    let clients = process.env.PUBLIC_URL + '/uploads/clients.webp?new1000';
    let home = process.env.PUBLIC_URL + '/uploads/home.webp?new';
    let final_products = [];

    products.forEach(item => {
        if (item['visible'] !== 0) {
            let path = item['image'];
            if (typeof(item['image']) === 'object') {
                path = item['image'][0];
            }
            final_products.push(
                <div className="work-item" key={item['title'] + (typeof(item['image']) === 'object' ? item['image'][0] : item['image'])}>
                    <Link to={`${langPrefix}/product/${encodeURIComponent(item['title'])}`}>
                        <img
                            src={process.env.PUBLIC_URL + '/uploads/products/' + path}
                            alt={item['title']}
                            className="img-responsive products"
                            loading="lazy"
                        />
                        <h6 className="fh5co-work-title">{generateFullTitle(item, currentLang)}</h6>
                    </Link>
                </div>
            );
        }
    });

    return (
        <div>
            <SEO
                title={t('title')}
                description={t('meta_description')}
            />

            <div>
                <div className="fh5co-narrow-content">
                    <div className="row">
                        <div className="col-md-3 text-center" style={{ marginBottom: '20px' }}>
                            <div className="row">
                                <FaEnvelope size="2em" style={{
                                    padding: '0 5px 10px 0',
                                    display: 'block',
                                    margin: '0 auto',
                                    color: '#02B1EC'
                                }} />
                            </div>
                            <div className="row">
                                <p className="contact-text">
                                    <a className="contact-email" href="mailto:info@tparan.am">
                                        info@tparan.am
                                    </a>
                                    <br />
                                    <a className="contact-email" href="mailto:corporate@tparan.am">
                                        corporate@tparan.am
                                    </a>
                                    <br />
                                    <a className="contact-email" href="mailto:marketing@tparan.am">
                                        marketing@tparan.am
                                    </a>
                                    <br />
                                    <a className="contact-email" href="mailto:tparan@tparan.am">
                                        tparan@tparan.am
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div className="col-md-3 text-center" style={{ marginBottom: '20px' }}>
                            <div className="row">
                                <FaMapMarkerAlt size="2em" style={{
                                    padding: '0 5px 10px 0',
                                    display: 'block',
                                    margin: '0 auto',
                                    color: '#02B1EC'
                                }} />
                            </div>
                            <div className="row">
                                <p className="contact-text">
                                    <a
                                        href="https://yandex.com/maps/-/CXQIRWy-"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="contact-address"
                                    >
                                        {t('addr_masiv')}
                                    </a><br/>
                                    <a
                                        href="https://yandex.com/maps/-/CXQIZYK-"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="contact-address"
                                    >
                                        {t('addr_mamuli')}
                                    </a><br/>
                                    <a
                                        href="https://yandex.com/maps/-/CXQIZBoY"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="contact-address"
                                    >
                                        {t('addr_itpark')}
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div className="col-md-3 text-center" style={{ marginBottom: '20px' }}>
                            <div className="row">
                                <FaMobileAlt size="2em" style={{
                                    padding: '0 5px 10px 0',
                                    display: 'block',
                                    margin: '0 auto',
                                    color: '#02B1EC'
                                }} />
                            </div>
                            <div className="row">
                                <p className="contact-text">
                                    {t('mob')} <a className="contact-phone" href="tel:+37491407038">(+374 91) 407038</a><br />
                                    <a className="contact-phone" href="tel:+37493407038">(+374 93) 407038</a><br />
                                    {t('tel')} <a className="contact-phone" href="tel:+37460446685">(+374 60) 446685</a>
                                </p>
                            </div>
                        </div>
                        <div className="col-md-3 text-center top-bar-social-lang" style={{ marginBottom: '20px' }}>
                            <div className="social-media">
                                <a href="https://instagram.com/tparan.am" target="_blank" rel="noopener noreferrer">
                                    <img width="44" height="44" src="https://img.icons8.com/fluency/144/instagram-new.png" alt="instagram"/>
                                </a>

                                <a href="https://facebook.com/tparan.am" target="_blank" rel="noopener noreferrer">
                                    <img width="44" height="44" src="https://img.icons8.com/fluency/144/facebook-new.png" alt="facebook"/>
                                </a>
                            </div>

                            <div className="desktop-lang-flags">
                                <LanguageSwitcher direction="vertical" />
                            </div>

                            <div className="mobile-lang-flags">
                                <LanguageSwitcher direction="horizontal" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="fh5co-counters header">
                <div className="fh5co-narrow-content">
                    <div className="row">
                        <div className="col-md-4 text-center">
                            <CountUp className="fh5co-counter" end={misc['services']} duration={2} delay={0} />
                            <span className="fh5co-counter-label">{t('offered_services')}</span>
                        </div>
                        <div className="col-md-4 text-center">
                            <CountUp className="fh5co-counter" end={misc['clients']} duration={2} delay={0} />
                            <span className="fh5co-counter-label">{t('partners')}</span>
                        </div>
                        <div className="col-md-4 text-center">
                            <CountUp className="fh5co-counter" end={misc['deals']} duration={2} delay={0} />
                            <span className="fh5co-counter-label">{t('deals')}</span>
                        </div>
                    </div>
                </div>
            </div>

            <img
                src={home}
                style={{ width: "100%", maxHeight: "80em", margin: "auto" }}
                alt={t('home_hero_alt')}
                className="img-responsive animated fadeInLeft"
            />

            <div className="fh5co-narrow-content">
                <h2 className="fh5co-heading animated fadeIn">{t('our_clients')}</h2>
                <img
                    src={clients}
                    style={{ maxWidth: "100%", margin: "auto" }}
                    alt={t('our_clients')}
                    className="img-responsive animated fadeInLeft"
                />

                <br />

                <h2 className="fh5co-heading animated fadeIn">{t('slogan')}</h2>
                <Masonry columns={{ xs: 1, sm: 2, md: 3 }} spacing={4} sx={{ mx: 'auto' }}>
                    {final_products}
                </Masonry>
            </div>
        </div>
    );
};

export default App;